import { Alert, MenuItem, Select, Snackbar } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const LanguageSwitcher = () => {
  const API_URL = import.meta.env.VITE_PUBLIC_API_URL;
  const { i18n } = useTranslation();
  const [error, setError] = useState(null);

  const lngs = {
    "en": { nativeName: "English", flag: "https://flagcdn.com/16x12/gb.png" },
    "el": { nativeName: "Greek", flag: "https://flagcdn.com/16x12/gr.png" },
  };

const handleChange = async (event) => {
  const newLang = event.target.value;
  try {
    console.log('Attempting language change to:', newLang);
    
    await i18n.changeLanguage(newLang);
    const response = await fetch(`${API_URL}/set-locale`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Language': newLang // Ensure header is sent
      },
      body: JSON.stringify({ locale: newLang }),
    });

    console.log('Server response:', await response.json());
    
    if (!response.ok) throw new Error('Server update failed');
  } catch (err) {
    console.error('Language change failed:', err);
    setError(err.message);
    i18n.changeLanguage(i18n.language);
  }
};
  return (
    <>
      <Select
        value={i18n.language}
        onChange={handleChange}
      >
        {Object.keys(lngs).map((lng) => (
          <MenuItem key={lng} value={lng}>
            <img src={lngs[lng].flag} alt={lngs[lng].nativeName} />
          </MenuItem>
        ))}
      </Select>
      
      <Snackbar open={!!error} autoHideDuration={6000} onClose={() => setError(null)}>
        <Alert severity="error">{error}</Alert>
      </Snackbar>
    </>
  );
};

export default LanguageSwitcher;